const getPriceAlertButtonVariantStyle = variant => {
  switch (variant) {
    case "green":
      return { backgroundColor: "#07A17233" };
    case "red":
      return { backgroundColor: "#F13E3E33" };
    default:
      return { backgroundColor: "#F1A72833" };
  }
};

export default getPriceAlertButtonVariantStyle;
